import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';
import MinBalanceCalculationMethods from '../MinBalanceCalculationMethods';
import BalanceTypes from '../BalanceTypes';

export class MinimumBalanceQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.MinimumBalanceQualifier';

    public static readonly NAME: string = 'Minimum Balance';

    minimumBalanceAmount: number = 0;

    balanceType: string = '';

    calculationMethod: string = '';

    constructor(qual?: IQualifier) {
      super(MinimumBalanceQualifier.CLASS, qual ? qual.id : null);

      if (qual) {
        this.minimumBalanceAmount = (qual as any).minimumBalanceAmount;
        this.balanceType = (qual as any).balanceType;
        this.calculationMethod = (qual as any).calculationMethod;
      }
    }

    getDescription(): string {
      return `Minimum Balance: ${this.minimumBalanceAmount}, Type: ${BalanceTypes[this.balanceType]
      }, Method: ${MinBalanceCalculationMethods[this.calculationMethod]}`;
    }

    clone(): IQualifier {
      const clone = new MinimumBalanceQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default MinimumBalanceQualifier;
